<template>
  <div>
    <Head title="Depósitos" />
    
    <app-toolbar name="Depósito" name-plural="Depósitos" create-href="/deposits/create" :export-buttons="false" back-href="/inventories" />

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Nombre</th>
          <th class="pb-4 pt-6 px-6">Alias</th>
          <th class="pb-4 pt-6 px-6">Región</th>
          <th class="pb-4 pt-6 px-6">Dirección</th>
          <th class="pb-4 pt-6 px-6 text-right">Acciones</th>
        </tr>
        <tr v-for="deposit in deposits['data']" :key="deposit.id" class="hover:bg-gray-50 focus-within:bg-gray-50">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 font-semibold text-gray-900 hover:text-orange-600" :href="`/deposits/${deposit.id}/edit`">
              {{ deposit.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 text-gray-600" :href="`/deposits/${deposit.id}/edit`">
              {{ deposit.alias || '-' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 text-gray-600" :href="`/deposits/${deposit.id}/edit`">
              {{ deposit.region ? deposit.region.name : '-' }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 text-gray-600" :href="`/deposits/${deposit.id}/edit`">
              {{ deposit.address || '-' }}
            </Link>
          </td>
          <td class="border-t px-6 py-4 text-right">
            <div class="flex items-center justify-end gap-2">
              <Link
                :href="`/inventories?tab=stock&deposit_id=${deposit.id}`"
                class="px-2.5 py-1.5 bg-orange-50 hover:bg-orange-100 text-orange-700 rounded-lg text-xs font-bold flex items-center gap-1.5 transition-colors shadow-2xs"
                title="Ver existencias de este depósito"
              >
                <i class="fa fa-boxes-stacked" />
                <span>Ver Stock</span>
              </Link>
              <Link
                :href="`/deposits/${deposit.id}/transfer`"
                class="px-2.5 py-1.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg text-xs font-bold flex items-center gap-1.5 transition-colors shadow-2xs"
                title="Ver traslados de este depósito"
              >
                <i class="fa fa-dolly text-orange-600" />
                <span>Traslados</span>
              </Link>
              <Link
                :href="`/deposits/${deposit.id}/edit`"
                class="px-2.5 py-1.5 bg-gray-50 hover:bg-gray-100 text-gray-500 hover:text-gray-900 border border-gray-200 rounded-lg text-xs font-medium flex items-center gap-1 transition-colors"
                title="Editar depósito"
              >
                <i class="fa fa-pen" />
                <span>Editar</span>
              </Link>
            </div>
          </td>
        </tr>
        <tr v-if="!deposits || !deposits['data'] || deposits['data'].length === 0">
          <td class="px-6 py-4 border-t text-center text-gray-400" colspan="5">No hay depósitos registrados.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="deposits.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import AppToolbar from '../../Shared/AppToolbar.vue'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    AppToolbar,
    Pagination,
  },
  layout: Layout,
  props: {
    deposits: Object,
  },
}
</script>
